import { memo } from "react";

interface JsonLdProps {
  data: Record<string, unknown>;
}

const JsonLd = memo(function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data, null, 2) }}
    />
  );
});

export default JsonLd;